export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_314.ef85545e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};